import React from "react";
import Banner from "../props/heading";
import { ExperienceTimeline, EducationTimeline } from "./timelines";


export default function About(){
    return(
        <>
            <div className="aboutMain">
                <Banner 
                    heading="heading aboutHeading"
                    title="title aboutMe"
                    myTitle={
                        <>
                            <span className="iAm">Hi, I am</span>
                            <div className="myDetails">
                                <div className="me"></div>
                            </div>
                          <span className="typing-name">MANPREET</span>
                        </>
                      }
                    /> 

                
                <div className="scroll aboutScroll">
                    <span>Scroll</span>
                    <div className="arrow">&#x2193;</div>
                </div>

                <div className="itIsMe">
                    <ExperienceTimeline />
                    <EducationTimeline />
                
                </div>
            </div>
            </>
        
    )
}